import styled, { css } from 'styled-components';
import { Form as AntForm } from 'antd';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { Alert as DefaultAlert } from 'ui/components/Alert';

import { FormProps, FormFiledProps, FormListProps } from './types';

import { captionStyle, labelStyle } from 'ui/components/Input/styled';

import { FC } from 'react';

export const StyledForm = styled<FC<FormProps>>(AntForm)`
  &&& .ant-form-item-required::before {
    display: none;
  }
`;

export const FormList = styled<FC<FormListProps>>(AntForm.List)``;

export const StyledFormItem = styled<FC<FormFiledProps>>(AntForm.Item)`
  margin-bottom: ${({ bottom }: { bottom?: string }) => bottom || '16px'};

  &:last-child {
    margin-bottom: ${({ bottom }: { bottom?: string }) => bottom || '0px'};
  }
  .ant-form-item-control-input {
    min-height: initial;
  }

  .ant-form-item-explain {
    ${captionStyle}

    &-error {
      color: ${colors.red500};
    }
  }

  &.ant-form-item-has-error {
    .ant-select:not(.ant-select-disabled) {
      & .ant-select-selector {
        border-color: ${colors.red600};
      }
      &:hover .ant-select-selector {
        border-color: ${colors.red600};
      }

      &:focus .ant-select-selector {
        border-color: ${colors.red600};
        box-shadow: 0 0 0 2px ${colors.red600};
        border-right-width: 1px;
        outline: 0;
      }
    }

    .ant-select-focused .ant-select-selector {
      box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
    }

    .ant-picker {
      border-color: ${colors.red600};
    }
  }

  .ant-form-item-label {
    ${labelStyle};
    height: initial;
    padding: 0;

    label {
      font-size: inherit;
      color: inherit;
    }
  }

  ${({ stretch }) =>
    stretch &&
    css`
      label {
        width: 100%;
      }
    `};
`;

export const Alert = styled(DefaultAlert)`
  margin-bottom: 20px;
`;

export const AlignRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;
